<template>
  <div class="box">
    <!-- 推荐职位筛选区 -->
    <div class="btm-screen">
      <div class="Filter-field">
        <div class="select-bar">
          公司行业：
          <p class="profession" v-if="echoVal.length == 0">不限</p>
          <p
            class="profession"
            v-else
            v-for="(item, index) in echoVal"
            :key="index"
          >
            {{ item.label }}
          </p>
          <!-- <p class="profession">IT</p>
          <p class="profession">客服</p> -->
          <p style="color: #fe574a; cursor: pointer" @click="handelProfession">
            [切换]
          </p>
        </div>
        <div class="select-bar">
          求职类型：
          <p class="firm-clickable"
            v-for="(item, index) in typeList"
            :key="index"
            :style="type == item.id ? 'color: #409eff ;' : ''"
            @click="handelClickType(item.id)"
          >
            {{ item.name }}
          </p>
        </div>
      </div>
      <!-- 薪资待遇 -->
      <div class="Filter-field">
        <p class="title">薪资待遇：</p>
        <div>
          <p class="firm-clickable"
            v-for="(item, index) in treatmentList"
            :key="index"
            :style="treatment == item.id ? 'color: #409eff ;' : ''"
            @click="handelClickTreatment(item)"
          >
            {{ item.name }}
          </p>
        </div>
      </div>
      <!-- 工作经验 -->
      <div class="Filter-field">
        <p class="title">工作经验：</p>
        <div>
          <p class="firm-clickable"
            v-for="(item, index) in expList"
            :key="index"
            :style="Exp == item.id ? 'color: #409eff ' : ''"
            @click="handelClickExp(item.id)"
          >
            {{ item.name }}
          </p>
        </div>
      </div>
      <!-- 学历要求 -->
      <div class="Filter-field">
        <p class="title">学历要求：</p>
        <div>
          <p class="firm-clickable"
            v-for="(item, index) in learnList"
            :key="index"
            :style="Learn == item.id ? 'color: #409eff ' : ''"
            @click="handelClickLearn(item.id)"
          >
            {{ item.name }}
          </p>
        </div>
      </div>
      <!-- 公司规模 -->
      <div class="Filter-field">
        <p class="title">公司规模：</p>
        <div>
          <p class="firm-clickable"
            v-for="(item, index) in scaleList"
            :key="index"
            :style="scale == item.id ? 'color: #409eff ' : ''"
            @click="handelClickScale(item.id)"
          >
            {{ item.name }}
          </p>
        </div>
      </div>
      <!-- 热门职位 -->
      <div class="Filter-field" v-if="Toggle == 2">
        <p class="title">热门职位：</p>
        <div>
          <p class="firm-clickable"
            v-for="(item, index) in hotPosition"
            :key="index"
            :style="Position == item.code ? 'color: #409eff ' : ''"
            @click="handelPosition(item.code)"
          >
            {{ item.name }}
          </p>
        </div>
      </div>
    </div>
    <Profession
      :industryTypeList="echoVal"
      :dialogProfession="dialogProfession"
      @handleClose="handleClose"
      @handleUnderstand="handleUnderstand"
    ></Profession>
  </div>
</template>

<script>
// 引入接口
import {
  getUserHomeHotDictPositions, // 用户首页热门职位（热门职位 推荐栏）
} from "../../../../assets/api/indexl";
// 引入切换行业组件
import Profession from "../../../../components/Profession.vue";
export default {
  props: {
    Toggle: {}, // 等于2时选中的是热门职位
  },
  data() {
    return {
      typeList: [
        { name: "不限", id: "" },
        { name: "全职", id: "0" },
        { name: "兼职", id: "1" },
      ], //求职类型
      treatmentList: [
        { name: "不限", id: "", min: "", max: "" },
        { name: "5k以下", id: "2", min: "", max: "5000" },
        { name: "5-8k", id: "3", min: "5000", max: "8000" },
        { name: "8-15k", id: "4", min: "8000", max: "15000" },
        { name: "15-20k", id: "5", min: "15000", max: "20000" },
        { name: "20-60k", id: "6", min: "20000", max: "60000" },
        { name: "60k以上", id: "7", min: "60000", max: "" },
      ], // 薪资待遇数据
      expList: [
        { name: "不限", id: "" },
        { name: "1年以内", id: "0" },
        { name: "1-3年", id: "1" },
        { name: "3-5年", id: "2" },
        { name: "5-10年", id: "3" },
        { name: "10年以上", id: "4" },
      ], // 工作经验数据
      learnList: [
        { name: "不限", id: "" },
        { name: "初中及以下", id: "0" },
        { name: "中专/中技", id: "1" },
        { name: "高中", id: "2" },
        { name: "大专", id: "3" },
        { name: "本科", id: "4" },
        { name: "硕士", id: "5" },
        { name: "博士", id: "6" },
      ], // 学历要求
      scaleList: [
        { name: "不限", id: "" },
        { name: "20人以下", id: "0" },
        { name: "20-99人", id: "1" },
        { name: "100-299人", id: "2" },
        { name: "300-499人", id: "3" },
        { name: "500-999人", id: "4" },
        { name: "1000-9999人", id: "5" },
        { name: "10000人以上", id: "6" },
      ], // 公司规模数据
      hotPosition: [], // 热门职位
      Exp: "", // 筛选工作经验
      Learn: "", // 筛选学历要求
      scale: "", // 筛选 公司规模
      type: "", // 筛选 职位类型
      treatment: "", // 筛选 薪资待遇
      Position: "", // 热门职位筛选
      dialogProfession: false, // 切换行业
      echoVal: [], // 选择的行业
    };
  },
  components: {
    Profession,
  },
  created() {
    this.getUserHomeHotDictPositions();
  },
  mounted() {},
  destroyed() {},
  methods: {
    // 用户首页热门职位（中类）
    async getUserHomeHotDictPositions() {
      const res = await getUserHomeHotDictPositions();
      console.log(res);
      if (res.code == 0) {
        this.hotPosition = res.data;
        this.Position = this.hotPosition[0].code;
      } else {
        //失败
        // this.$tool.PromptBox("error", res.msg);
      }
    },
    // 切换热门职业
    handelPosition(num) {
      this.Position = num;
      this.$emit("handelPosition", num);
    },
    // 切换行业
    handelProfession() {
      this.dialogProfession = true;
    },
    // 切换行业关闭弹窗
    handleClose() {
      this.dialogProfession = !this.dialogProfession;
    },
    // 切换行业弹窗确定
    handleUnderstand(num, val) {
      this.echoVal = val;
      // 关闭 行业切换弹窗
      this.dialogProfession = !this.dialogProfession;
      // 获得请求接口时参数的格式
      var arr = [];
      for (var i in val) {
        arr[i] = val[i].code;
      }
      this.$emit("handleUnderstand", arr);
    },
    // 筛选 工作经验
    handelClickExp(num) {
      this.Exp = num;
      this.$emit("handelClickExp", num);
    },
    // 筛选 学历要求
    handelClickLearn(num) {
      this.Learn = num;
      this.$emit("handelClickLearn", num);
    },
    // 筛选公司规模
    handelClickScale(num) {
      this.scale = num;
      this.$emit("handelClickScale", num);
    },
    // 筛选 求职类型
    handelClickType(num) {
      this.$emit("handelClickType", num);
      this.type = num;
    },
    // 筛选 薪资待遇
    handelClickTreatment(item) {
      this.$emit("handelClickTreatment", item.min, item.max);
      this.treatment = item.id;
    },
  },
};
</script>

<style scoped lang="less">
// 筛选区
.box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  // 推荐职位筛选区
  .btm-screen {
    width: 1136px;
    min-height: 10px;
    margin: auto;
    .Filter-field {
      height: 35px;
      line-height: 35px;
      margin: 13px 20px 13px 20px;
      // border: 1px solid gold;
      display: flex;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: #333300;
      font-weight: 400;
      .title {
        height: 100%;
      }
      div {
        // flex: 1;
        height: 100%;
        display: flex;
        p {
          margin-right: 15px;
          cursor: pointer;
        }
      }

      .select-bar {
        min-width: 10px;
        height: 100%;
        margin-right: 60px;
        .profession {
          color: #409eff ;
        }
        p {
          cursor: pointer;
        }
      }
    }
  }
}
</style>
